
import { getSectionPagesApi, getSubCatScreenApi, getfiltered_items, getAllBrandItemsApi, getSearchResultApi, getdeal_of_the_dayApi, clearance_saleApi, getAllItemsApi, getInfinteScrollItemsApi, gettop_selling_productsApi } from "../services/Apis"
import { useDispatch, useSelector } from "react-redux";
import { setcatloading, setsubcategoryScreen, setdisplayed_products, sethas_more, setsection_pages_Data, setsectionloading, setscrolled_products } from "../redux/categoryslice";
import { setloading7, setdeal_of_the_day_items, settrending_products, setclearence_sale_items, setloading10 } from "../redux/homeslice";
import { Navigate, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const Category = () => {
    const dispatch = useDispatch()

    const displayed_products = useSelector(state => state.categoryslice.displayed_products);
    const scrolled_products = useSelector(state => state.categoryslice.scrolled_products);
    const trending_products = useSelector(state => state.homeslice.trending_products);
    const location = useLocation();

    const navigate = useNavigate()


    const getSubCatScreenList = async (input_data) => {

        if (input_data.page <= 1) {
            dispatch(setcatloading(true))
        }

        if (window.location.pathname.split("/")[1] == 'brands') {
            var response = await getAllBrandItemsApi(input_data);
        } else if (window.location.pathname.split("/")[1] == 'search-result') {
            const queryParams = new URLSearchParams(location.search);
            const subcategoryValue = queryParams.get("subcategory");
            const subcategoryId = subcategoryValue ? subcategoryValue.split("_")[0] : 'search';
            input_data.subcategoryId = subcategoryId
            var response = await getSearchResultApi(input_data);
        } else {
            var response = await getSubCatScreenApi(input_data);
        }

        if (response.data.status == 'success') {


            if (response.data.data.hasOwnProperty('redirect_url')) {
                dispatch(setcatloading(true))
                if(response.data.data.type == 'subcategory'){
                    navigate(`/products-category/${response.data.data.redirect_url}`)
                }else if(response.data.data.type == 'brands'){
                    navigate(`/brands/${response.data.data.redirect_url}`)
                }else{
                    navigate(new URL(response.data.data.redirect_url).pathname)
                }
            } else {
                dispatch(setsubcategoryScreen(response.data.data))
                if (input_data.finalInput.length <= 0 && input_data.page <= 1 || window.location.pathname.split("/")[1] == 'search-result') {
                    dispatch(setdisplayed_products(response.data.data.display_items.products))
                }

                if (response.data.data.display_items.products.length < 50) {
                    dispatch(sethas_more(false))
                }

                if (input_data.page > 1) {
                    dispatch(setdisplayed_products([...displayed_products, ...response.data.data.display_items.products]))
                }
                dispatch(setcatloading(false))

            }

        } else {
            dispatch(setcatloading(true))
        }
    };

    const getInfiniteScrollList = async (type, page, sethas_more) => {
        if (page <= 1) {
            dispatch(setcatloading(true))
        }

        var response = await getInfinteScrollItemsApi(type, page);

        if (response.data.data.length == 0) {
            sethas_more(false)
        }

        if (page <= 1) {
            dispatch(setscrolled_products(response.data.data))
        }

        if (page > 1) {
            dispatch(setscrolled_products([...scrolled_products, ...response.data.data]))
        }

    };

    const getAllItems = async (slug, page, sethas_more) => {
        if (page <= 1) {
            dispatch(setcatloading(true))
        }

        var response = await getAllItemsApi(slug, page);

        if (response.data.data.length == 0) {
            sethas_more(false)
        }

        if (page <= 1) {
            dispatch(setscrolled_products(response.data.data))
        }

        if (page > 1) {
            dispatch(setscrolled_products([...scrolled_products, ...response.data.data]))
        }

    };

    const getdeal_of_the_dayList = async (page, sethas_more) => {
        if (page <= 1) {
            dispatch(setloading7(true))
        }

        var response = await getdeal_of_the_dayApi(page);

        dispatch(setloading7(false))
        if (page <= 1) {
            dispatch(setdeal_of_the_day_items(response.data.data))
            dispatch(settrending_products(response.data.data.trending_products))
        }

        if (response.data.data.trending_products == 0) {
            sethas_more(false)
        }

        if (page > 1) {
            dispatch(settrending_products([...trending_products, ...response.data.data.trending_products]))
        }

    };

    const getclearence_Sale_List = async (page, sethas_more) => {
        if (page <= 1) {
            dispatch(setloading10(true))
        }

        var response = await clearance_saleApi(page);

        dispatch(setloading10(false))
        if (page <= 1) {
            dispatch(setclearence_sale_items(response.data.data))
            dispatch(settrending_products(response.data.data.items))
        }

        if (response.data.data.items == 0) {
            sethas_more(false)
        }

        if (page > 1) {
            dispatch(settrending_products([...trending_products, ...response.data.data.items]))
        }

    };

    const gettop_selling_product = async (page, sethas_more) => {
        if (page <= 1) {
            dispatch(setloading7(true))
        }

        var response = await gettop_selling_productsApi(page);

        dispatch(setloading7(false))
        if (page <= 1) {
            dispatch(setdeal_of_the_day_items(response.data.data))
            dispatch(settrending_products(response.data.data.top_Selling_products))
        }

        if (response.data.data.top_Selling_products == 0) {
            sethas_more(false)
        }

        if (page > 1) {
            dispatch(settrending_products([...trending_products, ...response.data.data.top_Selling_products]))
        }

    };

    const getSectionPages = async (id) => {
        dispatch(setsectionloading(true))

        const response = await getSectionPagesApi(id);
        if (response.data.status == 'success') {
            dispatch(setsection_pages_Data(response.data.data))
            dispatch(setsectionloading(false))

        } else {
            dispatch(setsectionloading(false))
        }
    };


    const filtered_items = async (input_data) => {
        const response = await getfiltered_items(input_data);
        if (response.data.status == 'success') {
            dispatch(setdisplayed_products(response.data.data.products))

            if (response.data.data.products.length < 50) {
                dispatch(sethas_more(false))
            }

            if (input_data.page > 1) {
                dispatch(setdisplayed_products([...displayed_products, ...response.data.data.products]))
            }
        } else {
        }
    };

    return { getSubCatScreenList, getclearence_Sale_List, filtered_items, getAllItems, getInfiniteScrollList, getSectionPages, getdeal_of_the_dayList, gettop_selling_product };
};

export default Category;
